import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/styles/main.css'

// vue-meta for dynamic head tags (Vue 3 compatible version uses default export)
const app = createApp(App)
// removed incompatible `vue-meta` (v2) which is for Vue 2 — avoid plugin install
app.use(router)
app.use(ElementPlus)
app.mount('#app')
